function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import react, { useEffect, useState } from "react";
import useAxios from "../../Hooks/use-axios";
import useSearchInput from "../../Hooks/useSearchInput";
import moment from "moment";
import { toast } from "react-toastify";
import { getKYCStatus } from "../../utils/helpers";
import useBookingSummary from "../../Hooks/use-bookingSummary";
import { isM3M, isMahindra } from "../../utils/isClient";
import { logoutHandler, removeLocalTokens, removeSessionTokens } from "../../utils/tokens";
var useData = function useData(_ref) {
  var _authState$isAuthenti, _authState$token, _ref2, _ref3, _ref4, _ref5, _dealsState$isRefresh, _authState$rewardPoin, _ref6, _authState$totalRewar, _redux$store, _redux$store$getState;
  var isRewards = _ref.isRewards,
    isPoints = _ref.isPoints,
    isBundle = _ref.isBundle,
    config = _ref.config,
    cmsClient = _ref.cmsClient,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    appType = _ref.appType,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    topOffers = _useState2[0],
    setTopOffers = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    lifestyleOffers = _useState4[0],
    setLifestyleOffers = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    homeServicesOffers = _useState6[0],
    setHomeServicesOffers = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    financeOffers = _useState8[0],
    setFinanceOffers = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    externalOffers = _useState0[0],
    setExternalOffers = _useState0[1];
  // const [digitalAmenities, setDigitalAmenities] = useState([]);
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    electronicsOffers = _useState10[0],
    setElectronicsOffers = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    homeFurnishingOffers = _useState12[0],
    setHomeFurnishingOffers = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    bundleOffers = _useState14[0],
    setBundleOffers = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    vendors = _useState16[0],
    setVendors = _useState16[1];
  var _useState17 = useState(""),
    _useState18 = _slicedToArray(_useState17, 2),
    kycStatus = _useState18[0],
    setKycStatus = _useState18[1];
  // const [rewards, setRewards] = useState([]);
  // const [TV, setTV] = useState([]);
  // const [WashingMachine, setWashingMachine] = useState([]);
  // const [Fridge, setFridge] = useState([]);
  // const[microWave , setMicroWave]=useState([]);
  // const[airConditioner , setAirConditioner]=useState([]);
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    tVs = _useState20[0],
    setTVs = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    washingMachines = _useState22[0],
    setWashingMachines = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    fridges = _useState24[0],
    setFridges = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    microwaves = _useState26[0],
    setMicrowaves = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    airConditioners = _useState28[0],
    setAirConditioners = _useState28[1];
  // const [tagList, setTagList] = useState([]);
  // const [selectedTag, setSelectedTag] = useState(null);
  // const [totalPages, setTotalPages] = useState(0);
  // const [currentPage, setCurrentPage] = useState(0);
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    rewards = _useState30[0],
    setrewards = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    isRewardsLoaded = _useState32[0],
    setIsRewardsLoaded = _useState32[1];
  var location = (router === null || router === void 0 ? void 0 : router.location) || {};
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    replace: function replace() {}
  };
  var _useState33 = useState(0),
    _useState34 = _slicedToArray(_useState33, 2),
    cartAmount = _useState34[0],
    setCartAmount = _useState34[1];
  var _useState35 = useState([]),
    _useState36 = _slicedToArray(_useState35, 2),
    rewardsCategoryList = _useState36[0],
    setRewardsCategoryList = _useState36[1];
  var _useState37 = useState(1),
    _useState38 = _slicedToArray(_useState37, 2),
    totalPages = _useState38[0],
    setTotalPages = _useState38[1];
  var _useState39 = useState(1),
    _useState40 = _slicedToArray(_useState39, 2),
    currentPage = _useState40[0],
    setCurrentPage = _useState40[1];
  var loadMoreHandler = function loadMoreHandler() {
    setCurrentPage(function (prevState) {
      return prevState + 1;
    });
  };
  // Normalize redux shape – some hosts pass state under `auth` and other
  // slices while others flatten properties at top level.  mimicking the
  // connectre app, we prefer `redux.auth` values when available.
  var authState = (redux === null || redux === void 0 ? void 0 : redux.auth) || {};
  var dealsState = (redux === null || redux === void 0 ? void 0 : redux.deals) || (redux === null || redux === void 0 ? void 0 : redux.deal) || {};
  var isAuthenticated = (_authState$isAuthenti = authState.isAuthenticated) !== null && _authState$isAuthenti !== void 0 ? _authState$isAuthenti : redux === null || redux === void 0 ? void 0 : redux.isAuthenticated;
  var token = (_authState$token = authState.token) !== null && _authState$token !== void 0 ? _authState$token : redux === null || redux === void 0 ? void 0 : redux.token;
  var isRewardRefreshing = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_dealsState$isRefresh = dealsState.isRefreshRewards) !== null && _dealsState$isRefresh !== void 0 ? _dealsState$isRefresh : dealsState.isRewardRefreshing) !== null && _ref5 !== void 0 ? _ref5 : redux === null || redux === void 0 ? void 0 : redux.isRefreshRewards) !== null && _ref4 !== void 0 ? _ref4 : redux === null || redux === void 0 ? void 0 : redux.isRewardRefreshing) !== null && _ref3 !== void 0 ? _ref3 : authState.isRefreshRewards) !== null && _ref2 !== void 0 ? _ref2 : authState.isRewardRefreshing;
  // const totalRewardspoint = isPoints
  //   ? (authState.reloyRewardPoints ??
  //     redux?.reloyRewardPoints ??
  //     redux?.totalRewardspoint)
  //   : (authState.rewardPoints ??
  //     redux?.rewardPoints ??
  //     redux?.totalRewardspoint);

  var totalRewardspoint = (_authState$rewardPoin = authState.rewardPoints) !== null && _authState$rewardPoin !== void 0 ? _authState$rewardPoin : redux === null || redux === void 0 ? void 0 : redux.rewardPoints;
  console.log("USER REWARD POINTS STORE", totalRewardspoint);
  var totalRewardsLength = (_ref6 = (_authState$totalRewar = authState.totalRewards) !== null && _authState$totalRewar !== void 0 ? _authState$totalRewar : redux === null || redux === void 0 ? void 0 : redux.totalRewards) !== null && _ref6 !== void 0 ? _ref6 : redux === null || redux === void 0 ? void 0 : redux.totalRewardsLength;
  console.log("USER REWARDS LENGTH", totalRewardsLength);
  var queryParams = new URLSearchParams(location.search);
  var kycCallbackStatus = queryParams.get("status");
  var kycCallbackProcess = queryParams.get("process");
  var tagID = queryParams.get("tagid");
  var rewardCategoryID = queryParams.get("rewardCategoryId");
  // Set initial selected category from URL (if present), else null
  var _useState41 = useState(rewardCategoryID ? Number(rewardCategoryID) : null),
    _useState42 = _slicedToArray(_useState41, 2),
    selectedRewardCategory = _useState42[0],
    setSelectedRewardCategory = _useState42[1];
  // State for selected tag - object with tagId and categoryId
  var _useState43 = useState(null),
    _useState44 = _slicedToArray(_useState43, 2),
    selectedTag = _useState44[0],
    setSelectedTag = _useState44[1];
  useEffect(function () {
    if (rewardCategoryID) {
      setSelectedRewardCategory(Number(rewardCategoryID));
    }
  }, [rewardCategoryID]);
  var state = (redux === null || redux === void 0 || (_redux$store = redux.store) === null || _redux$store === void 0 || (_redux$store$getState = _redux$store.getState) === null || _redux$store$getState === void 0 ? void 0 : _redux$store$getState.call(_redux$store)) || {}; // Access the current store state via props
  useEffect(function () {
    if (tagID == Number(65)) {
      history.push("/bundle-deals");
    }
  }, [tagID]);

  // useEffect(() => {
  //     if (isAuthenticated) {
  //         getUserAccountSummary();
  //     }
  // }, [isAuthenticated]);

  var callback = function callback(searchValue) {
    var _window;
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("OfferSearch", {
      "Keyword ": "".concat(searchValue)
    });
    getHomeServicesOffers();
    getHomeFurnishingOffers();
    getLifestyleOffers();
    getElectronicOffers();
    getFinanceOffers();
    getExternalOffers();

    // getDigitalAmenities();
    getBundleOffers();
    getRewards();
  };
  var _useSearchInput = useSearchInput("", callback),
    _useSearchInput2 = _slicedToArray(_useSearchInput, 2),
    searchInput = _useSearchInput2[0],
    handleChange = _useSearchInput2[1];
  var _useState45 = useState(null),
    _useState46 = _slicedToArray(_useState45, 2),
    unauthorizedUserMessage = _useState46[0],
    setUnauthorizedUserMessage = _useState46[1];
  // const [userAccountSummary, setUserAccountSummary] = useState(null);
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var authActions = (redux === null || redux === void 0 ? void 0 : redux.authActions) || {};
  var _useBookingSummary = useBookingSummary({
      redux: {
        isAuthenticated: isAuthenticated,
        dispatch: dispatch,
        authActions: authActions
      },
      winnreAuth: winnreAuth,
      appType: appType,
      isPoints: isPoints
    }),
    userAccountSummary = _useBookingSummary.userAccountSummary,
    getUserAccountSummary = _useBookingSummary.getUserAccountSummary;
  var isInternalWebview = redux === null || redux === void 0 ? void 0 : redux.internalWebview;
  var dealAction = (redux === null || redux === void 0 ? void 0 : redux.dealAction) || {};
  var safeDispatch = function safeDispatch(actionCreator, payload) {
    if (dispatch && typeof actionCreator === "function") {
      dispatch(actionCreator(payload));
    }
  };

  // config provided via props

  var logout = function logout() {
    setLifestyleOffers([]);
    setHomeServicesOffers([]);
    setFinanceOffers([]);
    setExternalOffers([]);
    // setDigitalAmenities([]);
    if (isMahindra(config)) {
      removeSessionTokens();
    } else {
      removeLocalTokens();
    }
    if (dispatch) {
      logoutHandler(dispatch, winnreAuth, authActions);
    }
    safeDispatch(dealAction.clearAllCaches);
  };
  var _useAxios = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoadingTopDeals = _useAxios.isLoading,
    fetchTopOffers = _useAxios.sendRequest;
  var _useAxios2 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoadingExternal = _useAxios2.isLoading,
    fetchExternalOffers = _useAxios2.sendRequest;
  var _useAxios3 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoadingHomeServices = _useAxios3.isLoading,
    fetchHomeServicesOffers = _useAxios3.sendRequest;
  var _useAxios4 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoadingHomeFurnishing = _useAxios4.isLoading,
    fetchHomeFurnishingOffers = _useAxios4.sendRequest;
  var _useAxios5 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoadingLifestyle = _useAxios5.isLoading,
    error = _useAxios5.error,
    fetchLifestyle = _useAxios5.sendRequest;
  var _useAxios6 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoadingElectronics = _useAxios6.isLoading,
    fetchElectronicOffers = _useAxios6.sendRequest;
  var _useAxios7 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoadingFinance = _useAxios7.isLoading,
    fetchFinanceOffers = _useAxios7.sendRequest;
  // const { isLoading: isLoadingDigital, sendRequest: fetchDigitalAmenities } =
  //   useAxios({ winnreAuth, cmsClient });
  var _useAxios8 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoadingBundle = _useAxios8.isLoading,
    fetchBundleOffers = _useAxios8.sendRequest;
  var _useAxios9 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoadingrewards = _useAxios9.isLoading,
    fetchrewards = _useAxios9.sendRequest;
  var _useAxios0 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoadingRewardsCategory = _useAxios0.isLoading,
    fetchRewardsCategory = _useAxios0.sendRequest;
  var _useAxios1 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoadingHome = _useAxios1.isLoading,
    fetchHomeOffers = _useAxios1.sendRequest;
  var _useAxios10 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    fetchVendors = _useAxios10.sendRequest;
  var date = moment().format();

  //Get account summary data
  // const getUserAccountSummary = () => {
  //     winnreAuth({
  //         method: 'get',
  //         url: '/winnre/user/booking/account-summary'
  //     })
  //         .then((res) => {
  //             setUserAccountSummary(res);
  //         })
  //         .catch((e) => {
  //             setUserAccountSummary(null);
  //         });
  // };

  var getBundleOffers = function getBundleOffers() {
    var _state$deals;
    // console.log('TOP OFFERS');

    var bundleUrl;
    if (isAuthenticated) {
      bundleUrl = "/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=8&pageSize=10".concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    } else {
      bundleUrl = "/winnre/no-auth/deals/filter-v2?isVisibleToAll=true&status=PUBLISHED&clientId=".concat(config === null || config === void 0 ? void 0 : config.id, "&pageSize=10&isAscending=false&sortBy=priority&categoryList=8").concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "").concat(isRewards ? "&rewardsPage=true" : "");
    }
    var bundleOffer = (state === null || state === void 0 || (_state$deals = state.deals) === null || _state$deals === void 0 || (_state$deals = _state$deals.bundleOffers) === null || _state$deals === void 0 ? void 0 : _state$deals[bundleUrl]) || null;
    var url = bundleUrl + "&endDate=".concat(date);
    var method = "get";
    if (bundleOffer) {
      console.log("Using cached bundleOffer deals:", bundleOffer);
      setBundleOffers(bundleOffer);
    } else {
      fetchBundleOffers({
        isEncryptedResponse: true,
        url: url,
        method: method,
        isFormData: true
      }, function (data) {
        console.log("bundle offers all", data);
        if (isAuthenticated) {
          if ((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" || (data === null || data === void 0 ? void 0 : data.status) === "FAILED") {
            setBundleOffers([]);
            safeDispatch(dealAction.removeBundleOffersDealsByUrl, {
              url: bundleUrl
            });
            toast.error("Failed to load bundle offers");
            return;
          }
          if ((data === null || data === void 0 ? void 0 : data.status) === "TOKEN_EXPIRED" || (data === null || data === void 0 ? void 0 : data.status) === "INVALID_TOKEN") {
            if (isInternalWebview) {
              safeDispatch(authActions.setUnauthorizedUser, data.message);
              return;
            }
            logout();
            return;
          }
        }
        safeDispatch(dealAction.saveBundleOffersDeals, {
          url: bundleUrl,
          deals: (data === null || data === void 0 ? void 0 : data.content) || []
        });
        setBundleOffers((data === null || data === void 0 ? void 0 : data.content) || []);
      });
    }
  };
  var getTopOffers = function getTopOffers() {
    var _state$deals2;
    console.log("TOP OFFERS");
    var topUrl;
    if (isAuthenticated) {
      topUrl = "/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=1,2,3,10,11&pageSize=10&tagList=52".concat(isRewards ? "&rewardsPage=true" : "");
    } else {
      topUrl = "/winnre/no-auth/deals/filter-v2?isVisibleToAll=true&tagList=52&status=PUBLISHED&clientId=".concat(config === null || config === void 0 ? void 0 : config.id, "&pageSize=10&isAscending=false&sortBy=priority&categoryList=1,2,3,10,11 ").concat(isRewards ? "&rewardsPage=true" : "");
    }
    var method = "get";
    var topOffers = (state === null || state === void 0 || (_state$deals2 = state.deals) === null || _state$deals2 === void 0 || (_state$deals2 = _state$deals2.topOffers) === null || _state$deals2 === void 0 ? void 0 : _state$deals2[topUrl]) || null;
    var url = topUrl + "&endDate=".concat(date);
    if (topOffers) {
      console.log("Using cached top deals:", topOffers);
      setTopOffers(topOffers);
    } else {
      fetchTopOffers({
        isEncryptedResponse: true,
        url: url,
        method: method,
        isFormData: true
      }, function (data) {
        if (isAuthenticated) {
          if ((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" || (data === null || data === void 0 ? void 0 : data.status) === "FAILED") {
            setTopOffers([]);
            toast.error("Failed to load offers of the month");
            return;
          }
          if ((data === null || data === void 0 ? void 0 : data.status) === "TOKEN_EXPIRED" || (data === null || data === void 0 ? void 0 : data.status) === "INVALID_TOKEN") {
            if (isInternalWebview) {
              safeDispatch(authActions.setUnauthorizedUser, data.message);
              return;
            }
            logout();
            return;
          }
        }
        safeDispatch(dealAction.saveTopOffersDeals, {
          url: topUrl,
          deals: (data === null || data === void 0 ? void 0 : data.content) || []
        });
        setTopOffers((data === null || data === void 0 ? void 0 : data.content) || []);
      });
    }
  };
  var getVendors = function getVendors() {
    var url;
    if (isAuthenticated) {
      url = "/winnre/user/vendors/getAllByFilter?pageSize=30&categoryIds=1,2,3,10,11 ".concat(isRewards ? "&rewardsPage=true" : "");
    } else {
      url = "/winnre/no-auth/vendors/getAllByFilter?pageSize=30&categoryIds=1,2,3,10,11".concat(isRewards ? "&rewardsPage=true" : "");
    }
    var method = "get";
    fetchVendors({
      isEncryptedResponse: true,
      url: url,
      method: method,
      isFormData: true
    }, function (data) {
      console.log("vendor data", data === null || data === void 0 ? void 0 : data.content);
      if ((data === null || data === void 0 ? void 0 : data.status) === "TOKEN_EXPIRED" || (data === null || data === void 0 ? void 0 : data.status) === "INVALID_TOKEN") {
        if (isInternalWebview) {
          safeDispatch(authActions.setUnauthorizedUser, data.message);
          return;
        }
        logout();
        return;
      }
      setVendors(data === null || data === void 0 ? void 0 : data.content);
    });
  };
  var getHomeServicesOffers = function getHomeServicesOffers() {
    var _state$deals3;
    // console.log('move in');

    var homeServicesUrl;
    // console.log('TGAS WHEN GETTING DEALS', selectedCategories);
    if (isAuthenticated) {
      homeServicesUrl = "/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=2".concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    } else {
      homeServicesUrl = "/winnre/no-auth/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=".concat(config === null || config === void 0 ? void 0 : config.id, "&pageSize=5&isAscending=false&sortBy=priority&categoryList=2").concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    }
    var method = "get";
    var homeServicesOffers = (state === null || state === void 0 || (_state$deals3 = state.deals) === null || _state$deals3 === void 0 || (_state$deals3 = _state$deals3.homeServicesOffers) === null || _state$deals3 === void 0 ? void 0 : _state$deals3[homeServicesUrl]) || null;
    var url = homeServicesUrl + "&endDate=".concat(date);
    if (homeServicesOffers) {
      console.log("Using cached homeServicesOffers deals:", homeServicesOffers);
      setHomeServicesOffers(homeServicesOffers);
    } else {
      fetchHomeServicesOffers({
        isEncryptedResponse: true,
        url: url,
        method: method,
        // headers: isAuthenticated ? headers2 : '',
        // data: data1,
        isFormData: true
      }, function (data) {
        // console.log('DEAL DATA', data);
        if (isAuthenticated) {
          if ((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" || (data === null || data === void 0 ? void 0 : data.status) === "FAILED") {
            // console.log('failed');

            setUnauthorizedUserMessage((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" ? "Become our customer to avail deals." : "Something went wrong. Could not load offers. Please try again!");
            toast.error("Failed to load move in offers");
            setHomeServicesOffers([]);
            return;
          }
          if ((data === null || data === void 0 ? void 0 : data.status) === "TOKEN_EXPIRED" || (data === null || data === void 0 ? void 0 : data.status) === "INVALID_TOKEN") {
            if (isInternalWebview) {
              safeDispatch(authActions.setUnauthorizedUser, data.message);
              return;
            }
            logout();
            return;
          }
        }
        safeDispatch(dealAction.saveMoveInOffersDeals, {
          url: homeServicesUrl,
          deals: (data === null || data === void 0 ? void 0 : data.content) || []
        });
        setHomeServicesOffers(data.content || []);
      });
    }
  };
  var getHomeFurnishingOffers = function getHomeFurnishingOffers() {
    var _state$deals4;
    // console.log('FINANCE');
    var homeFurnishingUrl;
    if (isAuthenticated) {
      homeFurnishingUrl = "/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=11".concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    } else {
      homeFurnishingUrl = "/winnre/no-auth/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=".concat(config === null || config === void 0 ? void 0 : config.id, "&pageSize=5&isAscending=false&sortBy=priority&categoryList=11").concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    }
    var method = "get";
    var homeFurnishingOffers = (state === null || state === void 0 || (_state$deals4 = state.deals) === null || _state$deals4 === void 0 || (_state$deals4 = _state$deals4.homeFurnishingOffers) === null || _state$deals4 === void 0 ? void 0 : _state$deals4[homeFurnishingUrl]) || null;
    var url = homeFurnishingUrl + "&endDate=".concat(date);
    if (homeFurnishingOffers) {
      console.log("Using cached homeFurnishingOffers deals:", homeFurnishingOffers);
      setHomeFurnishingOffers(homeFurnishingOffers);
    } else {
      fetchHomeFurnishingOffers({
        isEncryptedResponse: true,
        url: url,
        method: method,
        isFormData: true
      }, function (data) {
        if (isAuthenticated) {
          if ((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" || (data === null || data === void 0 ? void 0 : data.status) === "FAILED") {
            setUnauthorizedUserMessage((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" ? "Become our customer to avail deals." : "Something went wrong. Could not load offers. Please try again!");
            toast.error("Failed to load home financing deals");
            setHomeFurnishingOffers([]);
            return;
          }
          if ((data === null || data === void 0 ? void 0 : data.status) === "TOKEN_EXPIRED" || (data === null || data === void 0 ? void 0 : data.status) === "INVALID_TOKEN") {
            if (isInternalWebview) {
              safeDispatch(authActions.setUnauthorizedUser, data.message);
              return;
            }
            logout();
            return;
          }
        }
        safeDispatch(dealAction.saveHomeOffersDeals, {
          url: homeFurnishingUrl,
          deals: (data === null || data === void 0 ? void 0 : data.content) || []
        });
        setHomeFurnishingOffers(data.content || []);
      });
    }
  };
  var getLifestyleOffers = function getLifestyleOffers() {
    var _state$deals5;
    // console.log('LIFESTYLE BENEFITS');

    var lifestyleUrl;
    if (isAuthenticated) {
      lifestyleUrl = "/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=1".concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    } else {
      lifestyleUrl = "/winnre/no-auth/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=".concat(config === null || config === void 0 ? void 0 : config.id, "&pageSize=5&isAscending=false&sortBy=priority&categoryList=1").concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    }
    var method = "get";
    var lifestyleOffers = (state === null || state === void 0 || (_state$deals5 = state.deals) === null || _state$deals5 === void 0 || (_state$deals5 = _state$deals5.lifestyleOffers) === null || _state$deals5 === void 0 ? void 0 : _state$deals5[lifestyleUrl]) || null;
    var url = lifestyleUrl + "&endDate=".concat(date);
    if (lifestyleOffers) {
      console.log("Using cached lifestyleOffers deals:", lifestyleOffers);
      setLifestyleOffers(lifestyleOffers);
    } else {
      fetchLifestyle({
        isEncryptedResponse: true,
        url: url,
        method: method,
        isFormData: true
      }, function (data) {
        console.log("LIFESTYLE", data);
        if (isAuthenticated) {
          if ((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" || (data === null || data === void 0 ? void 0 : data.status) === "FAILED") {
            setUnauthorizedUserMessage((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" ? "Become our customer to avail deals." : "Something went wrong. Could not load offers. Please try again!");
            toast.error("Failed to load lifestyle offers");
            safeDispatch(dealAction.removeBenefitsOffersDealsByUrl, {
              url: lifestyleUrl
            });
            setLifestyleOffers([]);
            return;
          }
          if ((data === null || data === void 0 ? void 0 : data.status) === "TOKEN_EXPIRED" || (data === null || data === void 0 ? void 0 : data.status) === "INVALID_TOKEN") {
            if (isInternalWebview) {
              safeDispatch(authActions.setUnauthorizedUser, data.message);
              return;
            }
            logout();
            return;
          }
        }
        safeDispatch(dealAction.saveBenefitsoffersDeals, {
          url: lifestyleUrl,
          deals: isM3M(config) ? data.content.filter(function (item) {
            return !item.tags.some(function (tag) {
              return tag.name === "M3M One";
            });
          }) : data.content || []
        });
        setLifestyleOffers(isM3M(config) ? data.content.filter(function (item) {
          return !item.tags.some(function (tag) {
            return tag.name === "M3M One";
          });
        }) : data.content || []);
      });
    }
  };
  var getElectronicOffers = function getElectronicOffers() {
    var _state$deals6;
    // console.log('FINANCE');
    var financeUrl;
    if (isAuthenticated) {
      financeUrl = "/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=10".concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    } else {
      financeUrl = "/winnre/no-auth/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=".concat(config === null || config === void 0 ? void 0 : config.id, "&pageSize=5&isAscending=false&sortBy=priority&categoryList=10").concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    }
    var method = "get";
    var electronicsOffers = (state === null || state === void 0 || (_state$deals6 = state.deals) === null || _state$deals6 === void 0 || (_state$deals6 = _state$deals6.electronicsOffers) === null || _state$deals6 === void 0 ? void 0 : _state$deals6[financeUrl]) || null;
    var url = financeUrl + "&endDate=".concat(date);
    if (electronicsOffers) {
      console.log("Using cached electronicsOffers deals:", electronicsOffers);
      setElectronicsOffers(electronicsOffers);
    } else {
      fetchElectronicOffers({
        isEncryptedResponse: true,
        url: url,
        method: method,
        isFormData: true
      }, function (data) {
        if (isAuthenticated) {
          if ((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" || (data === null || data === void 0 ? void 0 : data.status) === "FAILED") {
            setUnauthorizedUserMessage((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" ? "Become our customer to avail deals." : "Something went wrong. Could not load offers. Please try again!");
            toast.error("Failed to load home financing deals");
            setElectronicsOffers([]);
            return;
          }
          if ((data === null || data === void 0 ? void 0 : data.status) === "TOKEN_EXPIRED" || (data === null || data === void 0 ? void 0 : data.status) === "INVALID_TOKEN") {
            if (isInternalWebview) {
              safeDispatch(authActions.setUnauthorizedUser, data.message);
              return;
            }
            logout();
            return;
          }
        }
        safeDispatch(dealAction.saveElectronicOffersDeals, {
          url: financeUrl,
          deals: (data === null || data === void 0 ? void 0 : data.content) || []
        });
        setElectronicsOffers(data.content || []);
      });
    }
  };
  var getFinanceOffers = function getFinanceOffers() {
    var _state$deals7;
    // console.log('FINANCE');
    var financeUrl;
    if (isAuthenticated) {
      financeUrl = "/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=3".concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    } else {
      financeUrl = "/winnre/no-auth/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=".concat(config === null || config === void 0 ? void 0 : config.id, "&pageSize=5&isAscending=false&sortBy=priority&categoryList=3").concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    }
    var method = "get";
    var financeOffers = (state === null || state === void 0 || (_state$deals7 = state.deals) === null || _state$deals7 === void 0 || (_state$deals7 = _state$deals7.financeOffers) === null || _state$deals7 === void 0 ? void 0 : _state$deals7[financeUrl]) || null;
    var url = financeUrl + "&endDate=".concat(date);
    if (financeOffers) {
      console.log("Using cached financeOffers deals:", financeOffers);
      setFinanceOffers(financeOffers);
    } else {
      fetchFinanceOffers({
        isEncryptedResponse: true,
        url: url,
        method: method,
        isFormData: true
      }, function (data) {
        if (isAuthenticated) {
          if ((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" || (data === null || data === void 0 ? void 0 : data.status) === "FAILED") {
            setUnauthorizedUserMessage((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" ? "Become our customer to avail deals." : "Something went wrong. Could not load offers. Please try again!");
            toast.error("Failed to load home financing deals");
            setFinanceOffers([]);
            return;
          }
          if ((data === null || data === void 0 ? void 0 : data.status) === "TOKEN_EXPIRED" || (data === null || data === void 0 ? void 0 : data.status) === "INVALID_TOKEN") {
            if (isInternalWebview) {
              safeDispatch(authActions.setUnauthorizedUser, data.message);
              return;
            }
            logout();
            return;
          }
        }
        safeDispatch(dealAction.saveFinanceOffersDeals, {
          url: financeUrl,
          deals: (data === null || data === void 0 ? void 0 : data.content) || []
        });
        setFinanceOffers(data.content || []);
      });
    }
  };
  var getExternalOffers = function getExternalOffers() {
    var _state$deals8;
    // console.log('FINANCE');
    var externalUrl;
    if (isAuthenticated) {
      externalUrl = "/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=9".concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    } else {
      externalUrl = "/winnre/no-auth/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=".concat(config === null || config === void 0 ? void 0 : config.id, "&pageSize=5&isAscending=false&sortBy=priority&categoryList=9").concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(isRewards ? "&rewardsPage=true" : "");
    }
    var method = "get";
    var externalOffers = (state === null || state === void 0 || (_state$deals8 = state.deals) === null || _state$deals8 === void 0 || (_state$deals8 = _state$deals8.externalOffers) === null || _state$deals8 === void 0 ? void 0 : _state$deals8[externalUrl]) || null;
    var url = externalUrl + "&endDate=".concat(date);
    if (externalOffers) {
      console.log("Using cached finance deals:", externalOffers);
      setExternalOffers(externalOffers);
    } else {
      fetchExternalOffers({
        isEncryptedResponse: true,
        url: url,
        method: method,
        isFormData: true
      }, function (data) {
        console.log("external APII", data);
        if (isAuthenticated) {
          if ((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" || (data === null || data === void 0 ? void 0 : data.status) === "FAILED") {
            setUnauthorizedUserMessage((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" ? "Become our customer to avail deals." : "Something went wrong. Could not load offers. Please try again!");
            toast.error("Failed to load home financing deals");
            setExternalOffers([]);
            return;
          }
          if ((data === null || data === void 0 ? void 0 : data.status) === "TOKEN_EXPIRED" || (data === null || data === void 0 ? void 0 : data.status) === "INVALID_TOKEN") {
            if (isInternalWebview) {
              safeDispatch(authActions.setUnauthorizedUser, data.message);
              return;
            }
            logout();
            return;
          }
        }
        safeDispatch(dealAction.saveExternalOffersDeals, {
          url: externalUrl,
          deals: (data === null || data === void 0 ? void 0 : data.content) || []
        });
        setExternalOffers(data.content || []);
      });
    }
  };

  // const getDigitalAmenities = () => {
  //     // console.log('DIGITAL AMENITIES');
  //     let digitalUrl;
  //     if (isAuthenticated) {
  //         digitalUrl = `/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=5&categoryList=5${
  //             searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
  //         }${isRewards ? `&rewardsPage=true` : ''}`;
  //     } else {
  //         digitalUrl = `/winnre/no-auth/deals/filter-v2?isVisibleToAll=true&&status=PUBLISHED&clientId=${
  //             config?.id
  //         }&pageSize=5&isAscending=false&sortBy=priority&categoryList=5${
  //             searchInput.length > 0 ? `&searchValue=${searchInput}` : ''
  //         }${isRewards ? `&rewardsPage=true` : ''}`;
  //     }
  //     let method = 'get';
  //     const url = digitalUrl + `&endDate=${date}`;
  //     let digitalAmenity = state.deals.digitalAmenities[digitalUrl] || null;
  //     if (digitalAmenity) {
  //         console.log('Using cached digitalAmenities deals:', digitalAmenity);
  //         setDigitalAmenities(digitalAmenity);
  //     } else {
  //         fetchDigitalAmenities(
  //             {
  //                 isEncryptedResponse: true,
  //                 url,
  //                 method,
  //                 isFormData: true
  //             },
  //             (data) => {
  //                 console.log('Amenitiesdata', data);
  //                 if (isAuthenticated) {
  //                     if (
  //                         data?.status === 'UNAUTHORIZED' ||
  //                         data?.status === 'FAILED'
  //                     ) {
  //                         setUnauthorizedUserMessage(
  //                             data?.status === 'UNAUTHORIZED'
  //                                 ? 'Become our customer to avail deals.'
  //                                 : 'Something went wrong. Could not load offers. Please try again!'
  //                         );
  //                         toast.error('Failed to load digital amenities');

  //                         setDigitalAmenities([]);
  //                         return;
  //                     }
  //                     if (
  //                         data?.status === 'TOKEN_EXPIRED' ||
  //                         data?.status === 'INVALID_TOKEN'
  //                     ) {
  //                         if (isInternalWebview) {
  //                             dispatch(
  //                                 authActions.setUnauthorizedUser(
  //                                     data.message
  //                                 )
  //                             );
  //                             return;
  //                         }
  //                         logout();
  //                         return;
  //                     }
  //                 }
  //                 dispatch(
  //                     dealAction.saveDigitalAmenitiesDeals({
  //                         url: digitalUrl,
  //                         deals: data?.content || []
  //                     })
  //                 );
  //                 setDigitalAmenities(data.content || []);
  //             }
  //         );
  //     }
  // };
  // const getExclusiveRewards = () => {
  //     if (isRewards) {
  //         fetchRewards(
  //             {
  //                 isEncryptedResponse: isAuthenticated ? true : false,
  //                 url: `/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=50&categoryList=1,2,3,5&rewardsPage=true`,
  //                 method: 'get',
  //                 isFormData: true
  //             },
  //             (res) => {
  //                 console.log('exclusive Rewards', res?.content);
  //                 setRewards(res?.content);
  //             }
  //         );
  //     }
  // };

  var getRewards = function getRewards() {
    var oldCartData = isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData");
    // console.log('current selecttag', selectedTag);
    var cartData = {
      cartValues: [],
      totalMrp: 0,
      totalProduct: 0,
      totalPoints: 0
    };
    if (oldCartData) {
      cartData = JSON.parse(oldCartData);
    }
    console.log("REWARD API CALL");
    if (isRewards) {
      // Build URL parameters based on selection
      var filterParams = "";
      if (selectedTag) {
        // If a tag is selected, use tagList instead of rewardCategories
        filterParams += "&tagList=".concat(selectedTag.tagId);
      } else if (selectedRewardCategory) {
        // If only category is selected (no tag), use rewardCategories
        filterParams += "&rewardCategories=".concat(selectedRewardCategory);
      }
      var pageSize = isPoints ? 4 : 100;
      fetchrewards({
        isEncryptedResponse: isAuthenticated ? true : false,
        url: "/winnre/user/deals/filter-v2?".concat(isPoints ? "pageNumber=".concat(currentPage - 1, "&") : "", "status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=").concat(pageSize, "&rewardsPage=true").concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(filterParams).concat(cartData.totalPoints > 0 ? "&cartValue=".concat(cartData.totalPoints) : "").concat(appType === "winnre" || isPoints ? "&rewardType=RELOY_REWARDS" : "&rewardType=REFERRAL_REWARDS"),
        method: "get",
        isFormData: true
      }, function (res) {
        var _res$content;
        // console.log(" Rewards", totalRewardspoint - cartData.totalPoints);
        console.log("rewards from data", res);
        safeDispatch(authActions.setTotalRewards, res === null || res === void 0 || (_res$content = res.content) === null || _res$content === void 0 ? void 0 : _res$content.length);
        if ((res === null || res === void 0 ? void 0 : res.status) == "FAILED") {
          setrewards([]);
          setTotalPages(0);
          return;
        }
        if (totalRewardspoint > 0 && !isPoints) {
          var _res$content2;
          var filteredRewards = res === null || res === void 0 || (_res$content2 = res.content) === null || _res$content2 === void 0 ? void 0 : _res$content2.filter(function (val) {
            console.log("deal value", val.points, "remaining points", totalRewardspoint - cartData.totalPoints);
            return val.points <= totalRewardspoint - cartData.totalPoints;
          });
          setrewards(filteredRewards);
        } else if (isPoints) {
          setTotalPages(res === null || res === void 0 ? void 0 : res.totalPages);
          if (currentPage === 1) {
            // First page → replace so a re-fired effect (e.g. reward
            // points settling after login) can't duplicate products.
            setrewards((res === null || res === void 0 ? void 0 : res.content) || []);
          } else {
            // "Load more" pages → append.
            setrewards(function (prevState) {
              return prevState.concat((res === null || res === void 0 ? void 0 : res.content) || []);
            });
          }
        } else {
          setrewards(res === null || res === void 0 ? void 0 : res.content);
        }
        setIsRewardsLoaded(true);
      });
    }
  };
  // const getTags = () => {
  //     cmsClient({
  //         method: 'GET',
  //         url: `/cms_service/tags/getAll?categoryId=2`
  //     }).then((res) => {
  //         console.log(res);
  //         let tagList = res?.data?.content?.filter((item) =>
  //             [79, 80, 81, 82, 85, 86].includes(item.id)
  //         );
  //         setTagList(tagList);
  //         // console.log("Rewards tagList" , tagList);
  //     });
  // };

  var getRewardCategories = function getRewardCategories() {
    var url;
    if (isAuthenticated) {
      url = "/winnre/user/reward-categories/getAllByFilter?";
    } else {
      url = "/winnre/no-auth/reward-categories/getAllByFilter?";
    }
    var method = "get";
    url = url + "pageSize=50";
    fetchRewardsCategory({
      isEncryptedResponse: true,
      url: url,
      method: method,
      isFormData: true
    }, function (data) {
      console.log("Rewards Category", data === null || data === void 0 ? void 0 : data.content);
      if ((data === null || data === void 0 ? void 0 : data.status) == "FAILED") {
        setRewardsCategoryList([]);
        return;
      }
      setRewardsCategoryList(data === null || data === void 0 ? void 0 : data.content);
    });
  };
  useEffect(function () {
    if (isRewards) {
      getRewardCategories();
    }
  }, [isAuthenticated, isRewards]);
  useEffect(function () {
    if (isRewards) {
      setTopOffers([]);
    }
  }, [isRewards]);
  useEffect(function () {
    //FIROZ
    // setTopOffers([]);
    // getTags();
    if (totalRewardspoint == null) {
      return;
    }
    getRewards();
  }, [isRewards, isPoints, isAuthenticated, isRewardRefreshing, totalRewardspoint, selectedTag, selectedRewardCategory].concat(_toConsumableArray(isPoints ? [currentPage] : [])));
  useEffect(function () {
    if (isPoints) {
      setCurrentPage(1);
      setrewards([]);
    }
  }, [isPoints]);
  var checkKYCStatus = function checkKYCStatus() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref7$refresh = _ref7.refresh,
      refresh = _ref7$refresh === void 0 ? false : _ref7$refresh;
    getKYCStatus({
      winnreAuth: winnreAuth,
      refresh: refresh
    }).then(function (res) {
      console.log("returned from get KYC Status", res);
      setKycStatus(res.message);
    });
  };
  useEffect(function () {
    if (isRewards) {
      return;
    }
    if (isBundle) {
      getBundleOffers();
      return;
    }
    getTopOffers();
    getVendors();
    getLifestyleOffers();
    getFinanceOffers();
    getExternalOffers();
    getHomeServicesOffers();
    getHomeFurnishingOffers();
    getElectronicOffers();
    // getDigitalAmenities();
  }, [isRewards, isAuthenticated, isBundle]);
  useEffect(function () {
    if (isRewards && isAuthenticated) {
      checkKYCStatus({
        refresh: kycCallbackStatus === "success" && kycCallbackProcess === "DIGILOCKER"
      });
    }
  }, [isRewards, isAuthenticated, kycCallbackStatus, kycCallbackProcess]);
  useEffect(function () {
    if (!isRewards || !isAuthenticated) {
      return;
    }
    var refreshKycStatus = function refreshKycStatus() {
      checkKYCStatus({
        refresh: true
      });
    };
    var handleVisibilityChange = function handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        refreshKycStatus();
      }
    };
    window.addEventListener("focus", refreshKycStatus);
    window.addEventListener("pageshow", refreshKycStatus);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return function () {
      window.removeEventListener("focus", refreshKycStatus);
      window.removeEventListener("pageshow", refreshKycStatus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isRewards, isAuthenticated]);

  // Handler functions for category and tag selection
  var handleCategorySelection = function handleCategorySelection(categoryId) {
    setSelectedRewardCategory(categoryId);
    setSelectedTag(null); // Clear tag selection when category is selected
  };
  var handleTagSelection = function handleTagSelection(tagId, categoryId) {
    setSelectedTag({
      tagId: tagId,
      categoryId: categoryId
    });
    setSelectedRewardCategory(categoryId); // Keep the category selected for UI state
  };
  return {
    bundleOffers: bundleOffers,
    topOffers: topOffers,
    homeServicesOffers: homeServicesOffers,
    homeFurnishingOffers: homeFurnishingOffers,
    lifestyleOffers: lifestyleOffers,
    electronicsOffers: electronicsOffers,
    financeOffers: financeOffers,
    externalOffers: externalOffers,
    // digitalAmenities,
    vendors: vendors,
    isLoadingTopDeals: isLoadingTopDeals,
    isLoadingExternal: isLoadingExternal,
    isLoadingHomeServices: isLoadingHomeServices,
    isLoadingHomeFurnishing: isLoadingHomeFurnishing,
    isLoadingLifestyle: isLoadingLifestyle,
    isLoadingElectronics: isLoadingElectronics,
    isLoadingFinance: isLoadingFinance,
    // isLoadingDigital,
    error: error,
    unauthorizedUserMessage: unauthorizedUserMessage,
    handleChange: handleChange,
    searchInput: searchInput,
    kycStatus: kycStatus,
    isLoadingBundle: isLoadingBundle,
    rewards: rewards,
    isLoadingrewards: isLoadingrewards,
    // tagList,
    // selectedTag,
    // setSelectedTag,
    getRewards: getRewards,
    isRewardsLoaded: isRewardsLoaded,
    totalRewardspoint: totalRewardspoint,
    rewardsCategoryList: rewardsCategoryList,
    selectedRewardCategory: selectedRewardCategory,
    setSelectedRewardCategory: setSelectedRewardCategory,
    selectedTag: selectedTag,
    setSelectedTag: setSelectedTag,
    handleCategorySelection: handleCategorySelection,
    handleTagSelection: handleTagSelection,
    totalPages: totalPages,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
    loadMoreHandler: loadMoreHandler
  };
};
export default useData;